import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { changeFormStep } from '../../store/slices/registrationSlice';
import { FaSlidersH, FaWaveSquare, FaHashtag, FaUserFriends, FaCheckCircle } from 'react-icons/fa';

const steps = [
  { label: 'Confirm Identity', icon: <FaSlidersH />, route: '/setup/0' },
  { label: 'Setup Audio Stream', icon: <FaWaveSquare />, route: '/setup/1' },
  { label: 'Attach Social Feeds', icon: <FaHashtag />, route: '/setup/2' },
  { label: 'Setup Team', icon: <FaUserFriends />, route: '/setup/3' },
];

const StepNavBar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentStep = useSelector((state) => state.registration.currentStep);
  const completedSteps = useSelector((state) => state.registration.completed);

  const handleStepClick = (index) => {
    const canAccess = completedSteps
      .slice(0, index)
      .every((stepComplete) => stepComplete === true);

    if (index === 0 || canAccess) {
      dispatch(changeFormStep({ step: index }));
      navigate(steps[index].route);
    }
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '32px 12px',
    }}>
      {steps.map((step, index) => {
        const isCompleted = completedSteps[index];
        const isActive = index === currentStep;

        return (
          <div
            key={index}
            onClick={() => handleStepClick(index)}
            style={{
              cursor: index === 0 || isCompleted || isActive ? 'pointer' : 'not-allowed',
              opacity: index === 0 || isCompleted || isActive ? 1 : 0.4,
              color: isActive ? '#ffffff' : '#cccccc',
              textAlign: 'center',
              flex: 1
            }}
          >
            <div style={{
              fontSize: 30,
              marginBottom: 5,
              color: isActive ? '#ffffff' : isCompleted ? '#4caf50' : '#9e9e9e'
            }}>
              <span className='m-3'>{step.icon}</span>
            </div>
            <div style={{
              fontSize: 11,
              textTransform: 'uppercase',
              color: isActive ? '#ffffff' : '#9e9e9e',
              fontWeight: isActive ? 'bold' : 'normal'
            }}>
             <p className='h6'> {index + 1}. {step.label}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default StepNavBar;
